import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import MainHeader from "../../../components/mainheader/MainHeaderNew";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import { AiTwotoneDelete } from "react-icons/ai";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { deleteUser } from "../../../redux/slices/userSlice";
import { Link } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import CartIcon from "../../../components/Carticon/CartIcon";

const Client = () => {
  const navigate = useNavigate();

  const { userdetails } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [user, setUser] = useState([]);

  // console.log("userdetails", userdetails._id)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/user/getusersdetailsofid`,
          {
            headers: {
              token: localStorage.getItem("token"),
            },
          }
        );
        // console.log(response.data.data)
        setUser(response.data.data);
      } catch (error) {
        console.error("Error fetching user ", error);
      }
    };
    if (userdetails._id) {
      fetchUser();
    }
  }, [userdetails._id]);

  const handleDeleteClick = (id) => {
    const answer = window.confirm("Are You Sure !");
    if (answer) {
      dispatch(deleteUser(id));
    }
  };

  return (
    <>
      <StickySidebar />
      <MainHeader />

      <div
        className="container"
        style={{
          paddingTop: "100px", // 👈 Pushes content below fixed header
        }}
      >
        <div style={{ textAlign: "right", marginRight: "5px" }}>
          <button
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "1.05rem",
              color: "white",
              padding: "5px 15px",
              backgroundColor: "#198754",
              border: "none",
              borderRadius: "6px",
            }}
            onClick={() => navigate("/AddClient")}
          >
            Add Client
          </button>
        </div>

        <div className="white_card_body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Sr. No.</th>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">MobNumber</th>
                  <th scope="col">Status</th>

                  {/* <th scope="col">Password</th> */}
                  <th scope="col" style={{ width: "15%" }}>
                    Action
                  </th>

                  {/* <th scope="col">Tags</th> */}

                  {/* <th scope="col">Vendor</th> */}
                </tr>
              </thead>
              <tbody>
                {user &&
                  user.map((p, index) => (
                    <tr key={p._id}>
                      <th scope="row">{index + 1}</th>
                      <td>{p?.Name}</td>
                      <td>{p?.Email}</td>
                      <td>{p?.MobNumber}</td>
                      <td>
                        <button
                          className={
                            p?.status === 1
                              ? "btn btn-success"
                              : "btn btn-danger"
                          }
                          style={{ fontSize: "14px" }}
                        >
                          {p.status ? "Active" : "Inactive"}
                        </button>
                      </td>

                      {/* <td>{p.Password}</td> */}
                      <td>
                        <span>
                          <Link
                            to={`/AddClient/edit/${p._id}`}
                            style={{
                              backgroundColor: "#198754",
                              padding: "7px",
                              borderRadius: "8px",
                              color: "#fff",
                            }}
                          >
                            <FiEdit />
                          </Link>
                        </span>
                        &nbsp;
                        <span
                          style={{
                            backgroundColor: "#dc3545",
                            padding: "7px",
                            borderRadius: "8px",
                            color: "#fff",
                          }}
                          onClick={() => handleDeleteClick(p._id)}
                        >
                          <AiTwotoneDelete />
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Client;
